import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

export interface ULThemeProductNameProps extends HTMLAttributes<HTMLParagraphElement> {
  /**
   * Optional class names for additional styling or overriding default styles.
   */
  className?: string;
}

/**
 * Nome do produto exibido junto ao logo (ex.: "Vault Partners").
 *
 * O valor vem do `client_metadata.product_name` da Application Auth0 que
 * iniciou o login (Dashboard → Applications → Advanced Settings →
 * Application Metadata). Como o rendering ACUL é por tenant, esse é o canal
 * para diferenciar o rótulo por aplicação: apps sem essa metadata não
 * renderizam nada, então o rótulo é opt-in e não afeta os demais portais.
 *
 * Lê o contexto bruto (`window.universal_login_context`) em vez dos hooks do
 * SDK porque estes são exportados por subpath de screen — um componente
 * compartilhado não pode importá-los sem se acoplar a uma tela específica.
 */
const ULThemeProductName = ({
  className,
  ...rest
}: ULThemeProductNameProps) => {
  const productName =
    window.universal_login_context?.client?.metadata?.product_name;

  if (!productName) {
    return null;
  }

  const themedStyles =
    "mt-3 justify-text-header text-body-text font-body text-xs uppercase tracking-[0.25em]";

  return (
    <p className={cn(themedStyles, className)} {...rest}>
      {productName}
    </p>
  );
};

export default ULThemeProductName;
